import { createFileRoute } from '@tanstack/react-router';

import { DealersPage } from '@/features/operator/dealers-page';
import { validateSelectionSearch } from '@/features/operator/list-search';

export const Route = createFileRoute('/_operator/dealers')({
	// Стан списку і вибраний дилер — в адресі (§11 гайду).
	validateSearch: validateSelectionSearch,
	component: DealersPage,
});
